import { uniq, extend } from "lodash";

export function safeextend<T, T1 extends T>(target: T1, source: T): T1 {
    return extend(target, source) as T1;
}

export type ArrayType<T extends any[]> = T[number];

export function safebind<TFunction extends Function>(fn: TFunction, thisArg: any): TFunction;
export function safebind<T1, TResult>(fn: (t1: T1) => TResult, thisArg: any, t1: T1): () => TResult;
export function safebind<T1>(fn: (t1: T1) => void, thisArg: any, t1: T1): () => void;
export function safebind<T1, T2, TResult>(fn: (t1: T1, t2: T2) => TResult, thisArg: any, t1: T1): (t2: T2) => TResult;
export function safebind<T1, T2, TResult>(fn: (t1: T1, t2: T2) => TResult, thisArg: any, t1: T1, t2: T2): () => TResult;
export function safebind<T1, T2>(fn: (t1: T1, t2: T2) => void, thisArg: any, t1: T1): (t2: T2) => void;
export function safebind<T1, T2>(fn: (t1: T1, t2: T2) => void, thisArg: any, t1: T1, t2: T2): () => void;
export function safebind<T1, T2, T3>(fn: (t1: T1, t2: T2, t3: T3) => void, thisArg: any, t1: T1, t2: T2, t3: T3): () => void;
export function safebind<T1, T2, T3>(fn: (t1: T1, t2: T2, t3: T3) => void, thisArg: any, t1: T1, t2: T2): (t3: T3) => void;
export function safebind<T1, T2, T3>(fn: (t1: T1, t2: T2, t3: T3) => void, thisArg: any, t1: T1): (t2: T2, t3: T3) => void;
export function safebind<T1, T2, T3, T4>(fn: (t1: T1, t2: T2, t3: T3, t4: T4) => void, thisArg: any, t1: T1): (t2: T2, t3: T3, t4: T4) => void;
export function safebind<T1, T2, T3, T4>(fn: (t1: T1, t2: T2, t3: T3, t4: T4) => void, thisArg: any, t1: T1, t2: T2): (t3: T3, t4: T4) => void;
export function safebind<T1, T2, T3, T4>(fn: (t1: T1, t2: T2, t3: T3, t4: T4) => void, thisArg: any, t1: T1, t2: T2, t3: T3): (t4: T4) => void;
export function safebind<T1, T2, T3, T4>(fn: (t1: T1, t2: T2, t3: T3, t4: T4) => void, thisArg: any, t1: T1, t2: T2, t3: T3, t4: T4): () => void;
export function safebind<T1, T2, T3, T4, T5>(fn: (t1: T1, t2: T2, t3: T3, t4: T4, t5: T5) => void, thisArg: any, t1: T1): (t2: T2, t3: T3, t4: T4, t5: T5) => void;
export function safebind<T1, T2, T3, T4, T5>(fn: (t1: T1, t2: T2, t3: T3, t4: T4, t5: T5) => void, thisArg: any, t1: T1, t2: T2): (t3: T3, t4: T4, t5: T5) => void;
export function safebind<T1, T2, T3, T4, T5>(fn: (t1: T1, t2: T2, t3: T3, t4: T4, t5: T5) => void, thisArg: any, t1: T1, t2: T2, t3: T3): (t4: T4, t5: T5) => void;
export function safebind(fn: Function, thisArg: any, ...other: any[]) {
    return fn.bind(thisArg, ...other);
}

export function createWaitable() {
    let res: Function;
    var obj = {
        promise: new Promise((resolve: Function, reject: Function) => { res = resolve }),
        done: function () {
            res();
        }
    }
    return obj;
}

export const accumulate = <T, U>(ms: number, func: (params: T[]) => Promise<U[]>) => {
    let timeOut: NodeJS.Timer | null = null;
    let accumulatedParams: T[] = [];
    let current: Promise<U[]> | null = null;
    let currentResolve: ((value: U[] | PromiseLike<U[]>) => void) | null = null;

    const createTimeout = () => {
        timeOut = setTimeout(() => {
            timeOut = null;
            const result = func(accumulatedParams);
            accumulatedParams = [];
            currentResolve!(result);
            current = null;
        }, ms);
    }

    const create = () => new Promise<U[]>((resolve: (value: U[] | PromiseLike<U[]>) => void) => {
        currentResolve = resolve;
        createTimeout();
    });


    return (params: T[]) => {
        if (timeOut)
            clearTimeout(timeOut);

        accumulatedParams.push(...params);
        accumulatedParams = uniq(accumulatedParams);

        if (current)
            createTimeout();
        else
            current = create();

        return current;
    };
}

export function* sequence(from: number, to?: number, step?: number) {
    to = to == null ? Infinity : to;
    step = step == null ? 1 : step;
    for (var i = from; i <= to; i += step) {
        yield i;
    }
}
